<template>
  <div>
    <v-sheet class="py-4 py-md-6" color="primary">
      <TitleWidget dark>
        {{ title }}
      </TitleWidget>
    </v-sheet>

    <v-container>
      <template v-if="items.length">
        <section
          v-for="({ img, title, text }, keyItems) in items"
          :key="keyItems"
          class="item"
        >
          <v-row justify="center" no-gutters>
            <v-col cols="12" md="9">
              <TitleWidget small>
                {{ title }}
              </TitleWidget>

              <img
                v-if="img"
                @error="onError"
                class="d-block mt-6"
                loading="lazy"
                :src="files + img + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
                :alt="title"
                width="100%"
              />

              <div
                v-if="text"
                class="
                  grey--text
                  text--darken-2 text-subtitle-1
                  font-weight-light
                  mt-6
                  item-text
                  ck-content
                "
              >
                <span class="font-secondary" v-html="text"></span>
              </div>
            </v-col>
          </v-row>
        </section>
      </template>

      <section v-else>
        <v-alert type="info">
          Nenhum conteúdo adicionado até o momento.
        </v-alert>
      </section>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import DefaultImg from "../assets/img/default-img.png";

const _config = {
  mod: "about-objectives",
};

const _data = {
  title: "Objetivos",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    onError(e) {
      e.target.src = DefaultImg;
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  components: {
    TitleWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-text {
    line-height: 1.6;
  }
}
</style>
